import { STREAM_BASE } from './index';
import type { FixedQuality } from '@/engine/types';

/** Direct variant playlist per fixed quality (stream_0 = 360p lowest). */
export const VARIANT_FILE: Record<FixedQuality, string> = {
  '360p': 'stream_0.m3u8',
  '720p': 'stream_1.m3u8',
  '1080p': 'stream_2.m3u8',
};

/** ABR ladder index in master.m3u8 (sorted by bitrate ascending). */
export const LEVEL_IDX: Record<FixedQuality, number> = { '360p': 0, '720p': 1, '1080p': 2 };

export const masterUrl = (id: string): string => `${STREAM_BASE}/${id}/master.m3u8`;
export const variantUrl = (id: string, file: string): string => `${STREAM_BASE}/${id}/${file}`;
export const lowUrl = (id: string): string => variantUrl(id, VARIANT_FILE['360p']);
